import React, { useState } from 'react';
import { Box, TextField, Button } from '@mui/material';
import { useTranslation } from "react-i18next";

const blockedWords = ["done", "doing", "to do"];

const NewListModal = React.memo(({ onAddList, onClose }) => {
    const [localTitle, setLocalTitle] = useState("");
    const { t } = useTranslation();

    const handleTitleChange = (e) => {
        const inputValue = e.target.value;
        if (blockedWords.includes(inputValue.trim().toLowerCase())) {
            return;
        }
        setLocalTitle(inputValue);
    };

    const handleAdd = () => {
        const trimmedTitle = localTitle.trim();
        if (trimmedTitle !== "" && !blockedWords.includes(trimmedTitle.toLowerCase())) {
            onAddList(trimmedTitle);
            setLocalTitle("");
        }
    };

    return (
        <Box sx={{ backgroundColor: "#252224", m: 2, borderRadius: "8px" }}>
            <TextField
                autoFocus
                value={localTitle}
                onChange={handleTitleChange}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        handleAdd();
                    }
                }}
                placeholder="Enter list title"
                variant="outlined"
                fullWidth
                InputProps={{ style: { color: 'white' } }}
                InputLabelProps={{ style: { color: 'white' } }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: '#3d393b' },
                        '&:hover fieldset': { borderColor: '#3d393b' },
                        '&.Mui-focused fieldset': { borderColor: '#3d393b' },
                    },
                    '& .MuiInputBase-input': { color: 'white' },
                    '& .MuiInputBase-input::placeholder': { opacity: 1, color: 'white' },
                }}
            />
            <Box sx={{ mt: 1, display: 'flex', justifyContent: 'space-between' }}>
                <Button variant="contained" className="accept-button" onClick={handleAdd} sx={{padding: "8px 16px !important", width:"auto !important"}}>
                    {t("global.save")}
                </Button>
                <Button variant="text" className="decline-button" onClick={onClose} sx={{marginRight: "0px !important", padding: "8px 16px !important", width:"auto !important"}}>
                    {t("global.cancel")}
                </Button>
            </Box>
        </Box>
    );
});

export default NewListModal;
